import { render, staticRenderFns } from "./TBConclusion.vue?vue&type=template&id=a99430d2&scoped=true&"
import script from "./TBConclusion.vue?vue&type=script&lang=js&"
export * from "./TBConclusion.vue?vue&type=script&lang=js&"
import style0 from "./TBConclusion.vue?vue&type=style&index=0&id=a99430d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99430d2",
  null
  
)

export default component.exports